import { FC } from 'react'
import { Icon } from '@iconify/react'

import GoogleIntegrationButton from 'components/GoogleIntegrationButton'
import ConnectGoogleImg from 'assets/images/domain/connectGoogle.png'
import GoogleConnectionFeatures from 'components/GoogleConnectionFeatures'

import s from './ConnectGoogleAccount.module.css'

type Props = {
  companyId: string
}

export const ConnectGoogleAccount: FC<Props> = ({ companyId }) => {
  return (
    <>
      <div className={s.wrapper}>
        <div className={s.features}>
          <GoogleConnectionFeatures />
          <div className={s.connectGoogle}>
            <GoogleIntegrationButton companyId={companyId} />
          </div>
        </div>

        <div className={s.img}>
          <img src={ConnectGoogleImg} alt="connect-google" />
        </div>
      </div>
      <div className={s.disclaimer}>
        <Icon icon="lucide:shield-check" />
        <span className={s.copy}>
          We don&apos;t store or share any information from your Google account.
        </span>
      </div>
    </>
  )
}
